import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=b15f0238&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=b15f0238&prod&lang=scss&scoped=true"
import style1 from "./Product.vue?vue&type=style&index=1&id=b15f0238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f0238",
  null
  
)

export default component.exports